import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useSelector, useDispatch } from "react-redux";

// @ts-ignore: side-effect SCSS import is handled by the build pipeline
import "./AgentScheduling.scss";

import Cuate from "../../../images/cuate.png";
import Revoke from "../../../images/revoke.png";
import Alternative from "../../../images/alternative.png";

import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { Card } from "primereact/card";
import { InputTextarea } from "primereact/inputtextarea";
import { Messages } from "primereact/messages";

import {
  productionScheduleDetails,
  productionSchedule,
} from "./getProductionScheduleSlice";
import { saveUsageLogs, saveUsageLogsDetails } from "./saveUsageLogsSlice";
import {
  requestAlternativeSchedule,
  requestAlternativeScheduleDetails,
} from "./requestAlternativeScheduleSlice";
import {
  revokeCandidacy,
  revokeCandidacyDetails,
} from "./revokeCandidacySlice";
import {
  getConfirmAgentSchedule,
  getConfirmAgentScheduleDetails,
} from "./getConfirmAgentScheduleSlice";
import { isTokenExpired } from "../../../utils/msal-utils";
import AuthContext from "../shared-components/authContext";
import jwt_decode from "jwt-decode";
import { Message } from "primereact/message";
//import { OverlayPanel } from "primereact/overlaypanel";

export function AgentScheduling(props: any) {
  const [selectedSchedule1, setSelectedSchedule1] = useState<any>("");
  const [selectedSchedule2, setSelectedSchedule2] = useState<any>("");
  const [selectedSchedule3, setSelectedSchedule3] = useState<any>("");

  const [errorScheduleOption1, setErrorScheduleOption1] = useState(false);
  const [errorScheduleOption2, setErrorScheduleOption2] = useState(false);
  const [errorScheduleOption3, setErrorScheduleOption3] = useState(false);
  const [alternativeScheduleAlert, setAlternativeScheduleAlert] =
    useState(false);

  const [selectedDataValue, setSelectedDataValue] = useState<any>(null);
  const [isDropdownDisabled, setIsDropdownDisabled] = useState<boolean>(true);
  const [isButtonDisabled, setIsButtonDisabled] = useState<boolean>(false);

  // const [selectedScheduleValue1, setSelectedScheduleValue1] = useState("");
  // const [selectedScheduleValue2, setSelectedScheduleValue2] = useState("");
  // const [selectedScheduleValue3, setSelectedScheduleValue3] = useState("");

  const [displayBasic, setDisplayBasic] = useState(false);
  const [preferredScheduleContent, setPreferredScheduleContent] =
    useState(true);
  const [alternativeScheduleContent, setAlternateScheduleContent] =
    useState(false);
  const [revokeCandidacyContent, setRevokCandidacyContent] = useState(false);
  const [reasonRevokeCandidacyTextArea, setReasonRevokeCandidacyTextarea] =
    useState("");
  const [revokeCommentCharLimit, setRevokeCommentCharLimit] = useState<any>(0);
  const [alternateScheduleTextarea, setAlternateScheduleTextarea] =
    useState("");
  const [alternateCommentCharLimit, setAlternateCommentCharLimit] = useState(0);

  // const [alternateScheduleStartTime, setAlternateScheduleStartTime] = useState<
  //   Date | Date[] | undefined
  // >(undefined);
  // const [alternateScheduleEndTime, setAlternateScheduleEndTime] = useState<
  //   Date | Date[] | undefined
  // >(undefined);

  const onKeyUp = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    let keycode = e.which || e.keyCode;
    if (keycode === 20) {
      const value = (e.target as HTMLTextAreaElement).value;
      if (value.trim() !== "") {
        setReasonRevokeCandidacyTextarea(value);
        setAlternateScheduleTextarea(value);
      }
    }
  };

  const onKeyPress = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    let key = e.key;
    const arr = [
      "!",
      "#",
      "$",
      "%",
      "^",
      "&",
      "*",
      "(",
      ")",
      "-",
      "_",
      "+",
      "=",
      ";",
      ":",
      "'",
      '"',
      "<",
      ">",
      "/",
      "|",
      "\\",
      "{",
      "}",
      "[",
      "]",
      "~",
      "`",
    ];
    // Check if key pressed is a special character
    if (arr.includes(key)) {
      e.preventDefault();
    }
  };
  const onPaste = (e: React.ClipboardEvent<HTMLTextAreaElement>) => {
    e.preventDefault();
  };

  const [revokeCandidacyThanks, setRevokeCandidacyThanks] = useState(false);
  const [alternateScheduleThanks, setAlternateScheduleThanks] = useState(false);

  const productionScheduleData = useSelector(productionScheduleDetails);
  const dispatch = useDispatch();
  const [safeProductionScheduleData, setSafeProductionScheduleData] = useState<
    any[]
  >([]);
  // const [isMessageDisplayed, setIsMessageDisplayed] = useState(true);
  const saveUsageLogsDetailsData = useSelector(saveUsageLogsDetails);
  const getConfirmAgentScheduleDetailsData = useSelector(
    getConfirmAgentScheduleDetails
  );
  const requestAlternativeScheduleDetailsData = useSelector(
    requestAlternativeScheduleDetails
  );
  const revokeCandidacyDetailsData = useSelector(revokeCandidacyDetails);

  const myPreferredScheduleAlertMessage = useRef<Messages>(null);
  const alternativeSheduleAlertMessage = useRef<Messages>(null);
  const revokeCandidacyAlertMessage = useRef<Messages>(null);
  const [oracleId, setOracleId] = useState("0");
  const { nonSSOlogout } = useContext(AuthContext);
  const [productTrainingDateValue, setProductTrainingDateValue] = useState("");
  const [saveAndLockConfirmation, setSaveAndLockConfirmation] = useState(false);
  const [saveAndLockConfirmationModal, setSaveAndLockConfirmationModal] =
    useState(false);
  //const op = useRef<OverlayPanel | null>(null);
  const [isScheduleDeadlinePassed, setIsScheduleDeadlinePassed] =
    useState(false);
  // TTECONNECT-2715: "No schedules available" informational pop-up state.
  const [noScheduleDialogVisible, setNoScheduleDialogVisible] =
    useState(false);

  useEffect(() => {
    if (props.agentSchedulingVisible === true) {
      onClick("displayBasic");
      setPreferredScheduleContent(true);
      setAlternateScheduleContent(false);
      setRevokCandidacyContent(false);
      document.body.classList.add("no-scroll");
    } else {
      onHide("displayBasic");
      document.body.classList.remove("no-scroll");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);

  const dialogFuncMap = useMemo(
    () => ({
      displayBasic: setDisplayBasic,
    }),
    []
  );

  useEffect(() => {
    const SSOToken = localStorage.getItem("AccessToken");
    const nonSSOToken = localStorage.getItem("AccessToken-NonSSO");
    let id: any;

    if (nonSSOToken && isTokenExpired(nonSSOToken)) {
      //console.log("Non SSO Token Expired");
      nonSSOlogout();
    }

    if (SSOToken) {
      id = localStorage.getItem("oracleId");
    }
    if (nonSSOToken) {
      const decodedToken: any = jwt_decode(nonSSOToken);
      id = decodedToken?.oracleID;
    }
    setOracleId(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [localStorage.getItem("oracleId")]);

  useEffect(() => {
    if (isDropdownDisabled === true && props.agentSchedulingVisible === true) {
      setIsButtonDisabled(true);
    }
  }, [isDropdownDisabled, props]);

  const validateOnDialog = () => {
    if (props.agentSchedulingVisible === true) {
      if (preferredScheduleContent === true) {
        const schedules = [
          { selected: selectedSchedule1, setError: setErrorScheduleOption1 },
          { selected: selectedSchedule2, setError: setErrorScheduleOption2 },
          { selected: selectedSchedule3, setError: setErrorScheduleOption3 },
        ];

        let allSchedulesSelected = true;

        schedules.forEach(({ selected, setError }) => {
          if (!selected) {
            setError(true);
            allSchedulesSelected = false;
          } else {
            setError(false);
          }
        });

        const dropdownValues = [
          {
            ScheduleId: selectedSchedule1?.ProductionScheduleId,
            PreferenceId: 1,
          },
          {
            ScheduleId: selectedSchedule2?.ProductionScheduleId,
            PreferenceId: 2,
          },
          {
            ScheduleId: selectedSchedule3?.ProductionScheduleId,
            PreferenceId: 3,
          },
        ];

        if (allSchedulesSelected) {
          //onClick("displayBasic");
          //props.setDataFromChild(false);
          saveUsageLogsMethod(dropdownValues);
        }
      } else if (alternativeScheduleContent === true) {
        if (alternateScheduleTextarea === "") {
          setAlternativeScheduleAlert(true);
        } else {
          //setIsMessageDisplayed(false);
          selectedSchedule1 === ""
            ? setSelectedSchedule1("")
            : setSelectedSchedule1(selectedSchedule1);
          setSelectedSchedule2("");
          setSelectedSchedule3("");
          setAlternativeScheduleAlert(false);
          requestAlternativeScheduleMethod();
        }
      } else if (revokeCandidacyContent === true) {
        //setIsMessageDisplayed(false);
        setSelectedSchedule1("");
        setSelectedSchedule2("");
        setSelectedSchedule3("");
        revokeCandidacyMethod();
      }
    }
  };

  useEffect(() => {
    if (selectedSchedule1 !== "") {
      setErrorScheduleOption1(false);
    }

    if (selectedSchedule2 !== "") {
      setErrorScheduleOption2(false);
    }

    if (selectedSchedule3 !== "") {
      setErrorScheduleOption3(false);
    }
  }, [selectedSchedule1, selectedSchedule2, selectedSchedule3]);

  const renderFooter = (name: any) => {
    return (
      <div className="d-flex float-end">
        <Button
          label="Cancel"
          onClick={() => onHide(name)}
          className="p-button-outlined"
        />
        <Button
          label={
            preferredScheduleContent && !saveAndLockConfirmation
              ? "Save & Lock Schedule"
              : "Submit"
          }
          onClick={(e) => {
            if (preferredScheduleContent && !saveAndLockConfirmation) {
              setSaveAndLockConfirmationModal(true);
            } else {
              validateOnDialog();
            }
          }}
          className="p-button-primary"
          disabled={isButtonDisabled}
        />
        <Dialog
          visible={saveAndLockConfirmationModal}
          header="STOP: Confirm Schedule Preference"
          onHide={() => setSaveAndLockConfirmationModal(false)}
          footer={
            <>
              <Button
                label="No"
                className="p-button-secondary"
                onClick={() => setSaveAndLockConfirmationModal(false)}
              />
              <Button
                label="Yes"
                className="d-flex float-end"
                onClick={() => {
                  setSaveAndLockConfirmationModal(false);
                  validateOnDialog();
                }}
              />
            </>
          }
        >
          <p className="mt-2">
            Do you confirm your preferred schedules and want to proceed to the
            next step?
          </p>
          <p className="mt-2 text-sm">
            You can choose to go back and update your selection or submit to
            finalize your schedule. <br />
            <strong>You can't undo this action.</strong>
          </p>
        </Dialog>
      </div>
    );
  };

  //console.log(props);

  useEffect(() => {
    if (
      props?.classRosterAndRequestId?.ClassRequestId &&
      props?.classRosterAndRequestId?.ClassRosterId
    ) {
      const dataLoad = {
        classRosterId: props?.classRosterAndRequestId?.ClassRosterId
          ? props?.classRosterAndRequestId?.ClassRosterId
          : 0,
        classRequestId: props?.classRosterAndRequestId?.ClassRequestId
          ? props?.classRosterAndRequestId?.ClassRequestId
          : 0,
      };
      dispatch<any>(productionSchedule(dataLoad));
    }
  }, [
    dispatch,
    props?.classRosterAndRequestId?.ClassRequestId,
    props?.classRosterAndRequestId?.ClassRosterId,
  ]);

  const handleConfirmAgentSchedule = useCallback(() => {
    if (
      props?.classRosterAndRequestId?.ClassRequestId &&
      props?.classRosterAndRequestId?.ClassRosterId
    ) {
      const data = {
        classRosterId: props?.classRosterAndRequestId?.ClassRosterId
          ? props?.classRosterAndRequestId?.ClassRosterId
          : 0,
        classRequestId: props?.classRosterAndRequestId?.ClassRequestId
          ? props?.classRosterAndRequestId?.ClassRequestId
          : 0,
        oracleId: oracleId,
      };
      dispatch<any>(getConfirmAgentSchedule(data));
    }
  }, [
    dispatch,
    props?.classRosterAndRequestId?.ClassRequestId,
    props?.classRosterAndRequestId?.ClassRosterId,
    oracleId,
  ]);

  useEffect(() => {
    handleConfirmAgentSchedule();
  }, [handleConfirmAgentSchedule]);

  const onClick = useCallback(
    (name: keyof typeof dialogFuncMap) => {
      dialogFuncMap[`${name}`]((prev) => !prev);
      setRevokeCandidacyThanks(false);
      setAlternateScheduleThanks(false);
      setErrorScheduleOption1(false);
      setErrorScheduleOption2(false);
      setErrorScheduleOption3(false);
      handleConfirmAgentSchedule();
    },
    [dialogFuncMap, handleConfirmAgentSchedule]
  );

  const onHide = (name: keyof typeof dialogFuncMap) => {
    props.setDataFromChild(false);
    dialogFuncMap[`${name}`](false);
    setAlternateScheduleTextarea("");
    setAlternateCommentCharLimit(0);
    setReasonRevokeCandidacyTextarea("");
    setRevokeCommentCharLimit(0);
  };

  useEffect(() => {
    // Extract the value from getConfirmAgentScheduleDetailsData.getConfirmAgentScheduleData

    setIsDropdownDisabled(false);
    setSelectedDataValue(
      getConfirmAgentScheduleDetailsData?.getConfirmAgentScheduleData
    );

    setSelectedSchedule1(selectedDataValue);

    if (selectedDataValue) {
      setIsDropdownDisabled(true);
      setIsButtonDisabled(true);
    }

    // Check if productionScheduleData is an array or an object containing an array
    if (Array.isArray(productionScheduleData)) {
      setSafeProductionScheduleData(productionScheduleData);
    } else if (
      productionScheduleData &&
      Array.isArray(productionScheduleData.productionScheduleData)
    ) {
      setSafeProductionScheduleData(
        productionScheduleData.productionScheduleData
      );
    } else {
      setSafeProductionScheduleData([]);
    }
  }, [
    getConfirmAgentScheduleDetailsData,
    productionScheduleData,
    selectedDataValue,
  ]);

  const countryOptionTemplate = (option: any) => {
    return (
      <div id={option?.ProductionScheduleId}>
        {option?.ShiftTimings +
          " | " +
          option?.DaysWorked +
          " | " +
          option?.ShiftSpan +
          " hours "}
      </div>
    );
  };

  const selectedCountryTemplate = (option: any, props: any) => {
    if (option) {
      return (
        <div id={option?.ProductionScheduleId}>
          {option?.ShiftTimings +
            " | " +
            option?.DaysWorked +
            " | " +
            option?.ShiftSpan +
            " hours "}
        </div>
      );
    }

    return <span>{props.placeholder}</span>;
  };
  const selectedCountryTemplateDisplay = (option: any, props: any) => {
    if (option) {
      return (
        <div id={option?.ProductionScheduleId}>
          {"Start Timing: " +
            option?.ShiftTimings +
            " | Days: " +
            option?.DaysWorked +
            " | Shift Duration: " +
            option?.ShiftSpan +
            " hours"}
        </div>
      );
    }

    return <span>{props.placeholder}</span>;
  };

  const getModifiedOptions = (
    currentSelect: "select1" | "select2" | "select3",
    selectedValue: any
  ) => {
    const selectedSchedules = {
      select1: selectedSchedule1?.ProductionScheduleId,
      select2: selectedSchedule2?.ProductionScheduleId,
      select3: selectedSchedule3?.ProductionScheduleId,
    };

    return safeProductionScheduleData.map((option: any) => {
      const isCurrentSelect =
        option?.ProductionScheduleId === selectedSchedules[currentSelect];
      const isSelectedInOtherSelects = (
        Object.keys(selectedSchedules) as Array<
          "select1" | "select2" | "select3"
        >
      ).some(
        (key) =>
          key !== currentSelect &&
          option?.ProductionScheduleId === selectedSchedules[key]
      );

      return {
        ...option,
        disabled: !isCurrentSelect && isSelectedInOtherSelects,
      };
    });
  };

  // Save and Lock Dialog Information

  const saveUsageLogsMethod = (value: any) => {
    // Guard: only confirm a real user selection of 3 distinct schedules
    const ids = (value || [])
      .map((v: any) => Number(v?.ScheduleId))
      .filter((id: number) => Number.isFinite(id) && id > 0);
    if (ids.length !== 3 || new Set(ids).size !== 3) {
      myPreferredScheduleAddAlertMessage("Please select three different schedules");
      return;
    }
    const requestObject: any = {
      classRosterId: parseInt(props?.classRosterAndRequestId?.ClassRosterId),
      classRequestId: parseInt(props?.classRosterAndRequestId?.ClassRequestId),
      oracleId: parseInt(oracleId || "0"),
      productIDs: value,
    };
    dispatch<any>(saveUsageLogs(requestObject));
  };

  const requestAlternativeScheduleMethod = () => {
    alternativeSheduleClearAlertMessages();
    const requestObject: any = {
      classRosterId: props?.classRosterAndRequestId?.ClassRosterId,
      classRequestId: props?.classRosterAndRequestId?.ClassRequestId,
      oracleId: oracleId,
      debugEmail: "",
      comment: alternateScheduleTextarea,
    };

    dispatch<any>(requestAlternativeSchedule(requestObject));
  };

  const revokeCandidacyMethod = () => {
    revokeCandidacyClearAlertMessages();
    const requestObject: any = {
      classRosterId: props?.classRosterAndRequestId?.ClassRosterId,
      classRequestId: props?.classRosterAndRequestId?.ClassRequestId,
      oracleId: oracleId,
      debugEmail: "",
      comment: reasonRevokeCandidacyTextArea,
    };
    dispatch<any>(revokeCandidacy(requestObject));
  };

  // Alert Message for My Schedule

  useEffect(() => {
    if (
      saveUsageLogsDetailsData?.saveUsageLogsData?.data === null &&
      saveUsageLogsDetailsData?.saveUsageLogsState === "fulfilled" &&
      saveUsageLogsDetailsData?.saveUsageLogsMessage ===
        "Schedule is already locked for the Oracle Id."
    ) {
      myPreferredScheduleAddAlertMessage(
        "The selected schedule(s) is already locked, select a different schedule"
      );
    } else if (
      saveUsageLogsDetailsData?.saveUsageLogsState === "fulfilled" &&
      saveUsageLogsDetailsData?.saveUsageLogsMessage ===
        "Trainee doesn't exists in the Class Roster Id."
    ) {
      myPreferredScheduleAddAlertMessage("Trainee doesn't exists.");
    } else if (
      saveUsageLogsDetailsData?.saveUsageLogsData?.data === null &&
      saveUsageLogsDetailsData?.saveUsageLogsState === "failed"
    ) {
      myPreferredScheduleAddAlertMessage(
        "Something went wrong, try again later"
      );
    } else if (
      saveUsageLogsDetailsData?.saveUsageLogsState === "fulfilled" &&
      saveUsageLogsDetailsData?.saveUsageLogsMessage === "Success"
    ) {
      setPreferredScheduleContent(false);
      setAlternateScheduleThanks(true);
      setSaveAndLockConfirmation(true);
      setIsButtonDisabled(true);
    } else {
      setSelectedSchedule1(null);
      setSelectedSchedule2(null);
      setSelectedSchedule3(null);
      myPreferredScheduleClearAlertMessage();
      setPreferredScheduleContent(true);
      setSaveAndLockConfirmation(false);
    }
  }, [saveUsageLogsDetailsData]);

  const myPreferredScheduleAddAlertMessage = (message: any) => {
    myPreferredScheduleAlertMessage?.current?.show([
      {
        severity: "error",
        detail: message,
        sticky: true,
      },
    ]);
  };

  const myPreferredScheduleClearAlertMessage = () => {
    myPreferredScheduleAlertMessage?.current?.clear();
  };

  // Alert Messages for Alternative Schedule
  useEffect(() => {
    if (
      requestAlternativeScheduleDetailsData?.requestAlternativeScheduleData
        ?.data === null &&
      requestAlternativeScheduleDetailsData?.requestAlternativeScheduleState ===
        "fulfilled" &&
      requestAlternativeScheduleDetailsData?.requestAlternativeScheduleMessage ===
        "Record not found"
    ) {
      alternativeSheduleAddAlertMessages("Record not found");
    } else if (
      requestAlternativeScheduleDetailsData?.requestAlternativeScheduleData ===
        null &&
      requestAlternativeScheduleDetailsData?.requestAlternativeScheduleState ===
        "failed"
    ) {
      alternativeSheduleAddAlertMessages(
        "Something went wrong, try again later"
      );
    } else if (
      requestAlternativeScheduleDetailsData?.requestAlternativeScheduleMessage ===
      "Email sent successfully"
    ) {
      setAlternateScheduleTextarea("");
      alternativeSheduleClearAlertMessages();
      setAlternateScheduleContent(false);
      setAlternateScheduleThanks(true);
      setSaveAndLockConfirmation(false);
    }
  }, [requestAlternativeScheduleDetailsData]);

  const alternativeSheduleAddAlertMessages = (message: any) => {
    alternativeSheduleAlertMessage?.current?.show([
      {
        severity: "error",
        detail: message,
        sticky: true,
      },
    ]);
  };

  const alternativeSheduleClearAlertMessages = () => {
    alternativeSheduleAlertMessage.current?.clear();
  };

  // Alert Messages for Revoke Candidacy
  useEffect(() => {
    if (
      revokeCandidacyDetailsData?.revokeCandidacyData?.data === null &&
      revokeCandidacyDetailsData?.revokeCandidacyState === "fulfilled" &&
      revokeCandidacyDetailsData?.revokeCandidacyMessage === "Record not found"
    ) {
      revokeCandidacyAddAlertMessages("Record not found");
    } else if (
      revokeCandidacyDetailsData?.revokeCandidacyData === null &&
      revokeCandidacyDetailsData?.revokeCandidacyState === "failed"
    ) {
      revokeCandidacyAddAlertMessages("Something went wrong, try again later");
    } else if (
      revokeCandidacyDetailsData?.revokeCandidacyState === "fulfilled" &&
      revokeCandidacyDetailsData?.revokeCandidacyMessage ===
        "Email sent successfully"
    ) {
      setReasonRevokeCandidacyTextarea("");
      revokeCandidacyClearAlertMessages();
      setRevokCandidacyContent(false);
      setRevokeCandidacyThanks(true);
    }
  }, [revokeCandidacyDetailsData]);

  const revokeCandidacyAddAlertMessages = (message: any) => {
    revokeCandidacyAlertMessage?.current?.show([
      {
        severity: "error",
        detail: message,
        sticky: true,
      },
    ]);
  };

  const revokeCandidacyClearAlertMessages = () => {
    revokeCandidacyAlertMessage.current?.clear();
  };

  // =========================================================================
  // My Schedule due-date / deadline computation
  // RULE: Product Training Date + 14 days (mirrors API RunAutoAssignSchedule).
  // Fallback chain when ProductTrainingDate is absent: TTFDate -> NestingDate.
  // =========================================================================
  useEffect(() => {
    const ProductTrainingDate =
      props?.classRosterAndRequestId?.ProductTrainingDate;
    const TTFDate = props?.classRosterAndRequestId?.TTFDate;
    const NestingDate = props?.classRosterAndRequestId?.NestingDate;

    const formatDate = (d: Date) =>
      d.toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });

    let deadlineDate: Date | null = null;

    if (ProductTrainingDate) {
      const ptPlus14 = new Date(ProductTrainingDate);
      ptPlus14.setDate(ptPlus14.getDate() + 14);
      deadlineDate = ptPlus14;
    } else if (TTFDate) {
      deadlineDate = new Date(TTFDate);
    } else if (NestingDate) {
      deadlineDate = new Date(NestingDate);
    }

    // Guard against unparseable ASTT values (Invalid Date)
    if (deadlineDate && !isNaN(deadlineDate.getTime())) {
      setProductTrainingDateValue(formatDate(deadlineDate));
      setIsScheduleDeadlinePassed(new Date() > deadlineDate);
    }
  }, [
    props?.classRosterAndRequestId?.NestingDate,
    props?.classRosterAndRequestId?.ProductTrainingDate,
    props?.classRosterAndRequestId?.TTFDate,
  ]);

  // TTECONNECT-2715: Detect the "no schedules available" case. Only after the
  // production-schedule fetch has settled (to avoid a flash during loading) and
  // only on the preferred-schedule view when nothing is locked yet and the
  // deadline has not passed. safeProductionScheduleData is empty when the
  // class/roster has no schedules.
  useEffect(() => {
    const fetchSettled =
      productionScheduleData?.productionScheduleState === "fulfilled";
    const noSchedules =
      fetchSettled && safeProductionScheduleData.length === 0;

    if (
      props.agentSchedulingVisible === true &&
      preferredScheduleContent === true &&
      !isDropdownDisabled &&
      !selectedDataValue &&
      !isScheduleDeadlinePassed &&
      noSchedules
    ) {
      setNoScheduleDialogVisible(true);
    } else {
      setNoScheduleDialogVisible(false);
    }
  }, [
    props.agentSchedulingVisible,
    preferredScheduleContent,
    isDropdownDisabled,
    selectedDataValue,
    isScheduleDeadlinePassed,
    safeProductionScheduleData,
    productionScheduleData,
  ]);

  // TTECONNECT-2715: Build the pop-up title from ASTT fields
  // (RosterID, Program Name, Wave #). Falls back to a `.root` node if the
  // response is nested, and omits any missing parts gracefully.
  const getNoScheduleTitle = () => {
    const astt =
      props?.classRosterAndRequestId?.root ||
      props?.classRosterAndRequestId ||
      {};
    const rosterId = astt?.ClassRosterId ?? astt?.RosterId;
    const programName = astt?.ProgramName;
    const wave = astt?.Wave;

    const parts: string[] = [];
    if (rosterId !== undefined && rosterId !== null && `${rosterId}` !== "") {
      parts.push(`${rosterId}`);
    }
    if (programName) {
      parts.push(`${programName}`);
    }
    if (wave !== undefined && wave !== null && `${wave}` !== "") {
      parts.push(`Wave ${wave}`);
    }

    const suffix = parts.length > 0 ? ` ${parts.join(", ")}` : "";
    return `Schedules are not available for the class ${suffix}`;
  };

  const closeNoScheduleDialog = () => {
    // X and OK both simply close the pop-up and return to the My Schedule modal.
    setNoScheduleDialogVisible(false);
  };

  return (
    <Dialog
      header="My Schedule"
      visible={displayBasic}
      style={{ width: "75vw" }}
      footer={renderFooter("displayBasic")}
      onHide={() => onHide("displayBasic")}
      className="myShedule"
    >
      <div className="container-fluid p-0">
        <div className="row border-top">
          <div className="col-12 col-md-5 border-right order-last order-md-first">
            <img
              src={Cuate}
              alt="Cuate"
              className="img-fluid d-none d-md-block"
            />
            <Card className="border-0 shadow-none cardStyle">
              <>
                <div className="card-header">
                  <div className="row">
                    <div className="col-12 p-0">
                      <img src={Alternative} alt="Icon" />
                      <button
                        className="btn btn-bd-primary align-top mt-2"
                        onClick={() => {
                          setAlternateScheduleContent(false);
                          setPreferredScheduleContent(true);
                          setRevokCandidacyContent(false);
                          setAlternateScheduleThanks(false);
                          setRevokeCandidacyThanks(false);
                          setIsButtonDisabled(false);
                          handleConfirmAgentSchedule();
                          isDropdownDisabled === true
                            ? setIsButtonDisabled(true)
                            : setIsButtonDisabled(false);
                        }}
                      >
                        My schedule
                      </button>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12 p-0">
                      <img src={Alternative} alt="Icon" />
                      <button
                        className="btn btn-bd-primary align-top mt-2"
                        onClick={() => {
                          setAlternateScheduleContent(true);
                          setPreferredScheduleContent(false);
                          setRevokCandidacyContent(false);
                          setAlternateScheduleThanks(false);
                          setRevokeCandidacyThanks(false);
                          setIsButtonDisabled(false);
                        }}
                      >
                        I want an alternative schedule
                      </button>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12 p-0">
                      <img src={Revoke} alt="Icon" />
                      <button
                        className="btn btn-bd-primary align-top mt-2"
                        onClick={() => {
                          setAlternateScheduleContent(false);
                          setPreferredScheduleContent(false);
                          setRevokCandidacyContent(true);
                          setAlternateScheduleThanks(false);
                          setRevokeCandidacyThanks(false);
                          setIsButtonDisabled(false);
                        }}
                      >
                        Changed your mind?
                      </button>
                    </div>
                  </div>
                </div>
              </>
            </Card>
          </div>

          <div className="col-12 col-md-7 dialogContent">
            {preferredScheduleContent && (
              <>
                {isDropdownDisabled === false && !isScheduleDeadlinePassed && (
                  <div
                    className="justify-content-center d-flex ttec-info-text"
                    style={{
                      borderRadius: "8px",
                      padding: "10px 15px",
                    }}
                  >
                    <i
                      className="pi pi-clock mt-2"
                      style={{ fontSize: "2em" }}
                    ></i>
                    <div className="ms-2 pt-1 ttec-info-text">
                      You have till <strong>{productTrainingDateValue}</strong>{" "}
                      to provide your preferred schedule. If you have not
                      provided your preference by then, a schedule will be
                      automatically assigned for you.
                    </div>
                  </div>
                )}

                {isDropdownDisabled && (
                  <div
                    className="justify-content-center d-flex"
                    style={{
                      backgroundColor: "#D4D4FF",
                      borderRadius: "8px",
                      color: "#3A21AE",
                      padding: "10px 15px",
                      marginBottom: "35px",
                    }}
                  >
                    <i
                      className="pi pi-clock mt-2"
                      style={{ fontSize: "2em" }}
                    ></i>
                    <div className="ms-2 pt-1" style={{ fontSize: "18px" }}>
                      <span className="pt-2 w-100 confirmedScheduledText d-block">
                        Your confirmed schedule is -{" "}
                        {selectedCountryTemplateDisplay(selectedSchedule1, {
                          placeholder: "Select preferred schedule #1",
                        })}
                      </span>
                    </div>
                  </div>
                )}

                <Messages ref={myPreferredScheduleAlertMessage} />

                {isButtonDisabled === false && !isScheduleDeadlinePassed && (
                  <div className="row">
                    <div className="col-md-12">
                      <h4 className="mt-2">
                        Select your top three preferred schedules
                      </h4>
                    </div>
                  </div>
                )}
                {isScheduleDeadlinePassed && !isDropdownDisabled && (
                  <div className="alert alert-warning mt-4">
                    <div className="d-flex align-items-center">
                      <i
                        className="pi pi-exclamation-triangle me-3"
                        style={{ fontSize: "1.5rem" }}
                      ></i>
                      <div>
                        <p className="mb-0">
                          My Schedule feature has been disabled for you since it
                          is past due date for submitting preferred schedule.
                          Please reach out to your supervisor to discuss
                          further.
                        </p>
                      </div>
                    </div>
                  </div>
                )}
                <div className="row mt-4 mb-2">
                  <div className="col-md-12">
                    <figure
                      className={isScheduleDeadlinePassed ? "text-muted" : ""}
                    >
                      <ul>
                        {" "}
                        <li>
                          <strong>Note 1:</strong> M - Monday, T - Tuesday, W -
                          Wednesday, R - Thursday, F - Friday, Y - Saturday, S -
                          Sunday, "=" no availability
                        </li>
                        <li>
                          <strong>Note 2:</strong> The start times mentioned are
                          potential times and the final start time may vary.
                        </li>
                      </ul>
                    </figure>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12 col-lg-10 col-xl-9">
                    {/* First Dropdown */}
                    {!isDropdownDisabled &&
                      (isButtonDisabled === false ||
                        isScheduleDeadlinePassed) && (
                        <p
                          className={
                            isScheduleDeadlinePassed ? "text-muted m-0" : "m-0"
                          }
                        >
                          Schedule #1 (Start Time | Days | Shift Duration){" "}
                          <span className="align-baseline text-danger fw-bold">
                            *
                          </span>
                        </p>
                      )}
                    <Dropdown
                      value={selectedSchedule1}
                      onChange={(e) => {
                        setSelectedSchedule1(e.target.value);
                      }}
                      placeholder="Select preferred schedule #1"
                      dataKey="ProductionScheduleId"
                      className={
                        errorScheduleOption1 ? "p-invalid w-100" : "w-100"
                      }
                      itemTemplate={countryOptionTemplate}
                      options={
                        selectedDataValue === null
                          ? getModifiedOptions("select1", selectedSchedule1)
                          : safeProductionScheduleData
                      }
                      optionLabel="ShiftTimings | DaysWorked | ShiftSpan"
                      valueTemplate={selectedCountryTemplate(selectedSchedule1, {
                        placeholder: "Select preferred schedule #1",
                      })}
                      disabled={isDropdownDisabled || isScheduleDeadlinePassed}
                    />

                    {errorScheduleOption1 && !isScheduleDeadlinePassed && (
                      <small id="username-help" className="p-error ms-2">
                        Please select an option
                      </small>
                    )}

                    {/* Second Dropdown */}
                    {!isDropdownDisabled &&
                      (isButtonDisabled === false ||
                        isScheduleDeadlinePassed) && (
                        <>
                          <p
                            className={
                              isScheduleDeadlinePassed
                                ? "text-muted m-0 mt-3"
                                : "m-0 mt-3"
                            }
                          >
                            Schedule #2 (Start Time | Days | Shift Duration){" "}
                            <span className="align-baseline text-danger fw-bold">
                              *
                            </span>
                          </p>
                          <Dropdown
                            value={selectedSchedule2}
                            onChange={(e) => {
                              setSelectedSchedule2(e.target.value);
                            }}
                            placeholder="Select preferred schedule #2"
                            dataKey="ProductionScheduleId"
                            className={
                              errorScheduleOption2 ? "p-invalid w-100" : "w-100"
                            }
                            itemTemplate={countryOptionTemplate}
                            options={getModifiedOptions(
                              "select2",
                              selectedSchedule2
                            )}
                            optionLabel="ShiftTimings | DaysWorked | ShiftSpan"
                            valueTemplate={selectedCountryTemplate}
                            disabled={isScheduleDeadlinePassed}
                          />
                          {errorScheduleOption2 &&
                            !isScheduleDeadlinePassed && (
                              <small
                                id="username-help"
                                className="p-error ms-2"
                              >
                                Please select an option
                              </small>
                            )}
                        </>
                      )}

                    {/* Third Dropdown */}
                    {!isDropdownDisabled &&
                      (isButtonDisabled === false ||
                        isScheduleDeadlinePassed) && (
                        <>
                          <p
                            className={
                              isScheduleDeadlinePassed
                                ? "text-muted m-0 mt-3"
                                : "m-0 mt-3"
                            }
                          >
                            Schedule #3 (Start Time | Days | Shift Duration){" "}
                            <span className="align-baseline text-danger fw-bold">
                              *
                            </span>
                          </p>
                          <Dropdown
                            value={selectedSchedule3}
                            onChange={(e) => {
                              setSelectedSchedule3(e.target.value);
                            }}
                            placeholder="Select preferred schedule #3"
                            dataKey="ProductionScheduleId"
                            className={
                              errorScheduleOption3 ? "p-invalid w-100" : "w-100"
                            }
                            itemTemplate={countryOptionTemplate}
                            options={getModifiedOptions(
                              "select3",
                              selectedSchedule3
                            )}
                            optionLabel="ShiftTimings | DaysWorked | ShiftSpan"
                            valueTemplate={selectedCountryTemplate}
                            disabled={isScheduleDeadlinePassed}
                          />
                          {errorScheduleOption3 &&
                            !isScheduleDeadlinePassed && (
                              <small
                                id="username-help"
                                className="p-error ms-2"
                              >
                                Please select an option
                              </small>
                            )}
                        </>
                      )}
                  </div>
                </div>
              </>
            )}

            {alternativeScheduleContent && (
              <>
                <Message
                  severity="info"
                  text="NOTE: We will review alternate schedule requests, however, there
                is no guarantee that the requested alternate schedule will be
                assigned."
                  className="noteMessage"
                />

                <Messages ref={alternativeSheduleAlertMessage} />

                <p className="mt-2">
                  Please leave a reason for the alternate schedule request
                </p>

                <p className="mb-0 mt-3 pt-2">
                  Comment{" "}
                  <span className="align-baseline text-danger fw-bold">*</span>
                  {alternativeScheduleAlert && (
                    <small className="p-error ms-2 float-end">
                      Please provide the information
                    </small>
                  )}
                </p>
                <InputTextarea
                  value={alternateScheduleTextarea}
                  maxLength={500}
                  rows={10}
                  cols={50}
                  onKeyUp={onKeyUp}
                  onKeyPress={onKeyPress}
                  onPaste={onPaste}
                  placeholder="Please describe reason for alternative schedule"
                  onChange={(e) => {
                    const value = e.target.value;
                    setAlternateScheduleTextarea(value);
                    setAlternateCommentCharLimit(value.length);
                    setAlternativeScheduleAlert(value.trim().length === 0);
                    setIsButtonDisabled(value.trim().length === 0);
                  }}
                  autoResize
                  className={
                    alternativeScheduleAlert ? "p-invalid w-100" : "w-100"
                  }
                />

                <p className="pe-2 charLimit">
                  <span>*Required Field</span>
                  <span className="float-end">
                    {alternateCommentCharLimit} Character Limit
                  </span>
                </p>
              </>
            )}

            {revokeCandidacyContent && (
              <>
                <Messages ref={revokeCandidacyAlertMessage} />
                <p className="mt-2">
                  Let's talk through it and see how we can best help you. Please
                  provide detailed information below on why you need to withdraw
                  your application. We will review it and get back to you.
                </p>
                <p className="mb-0">
                  Comment{" "}
                  <span className="align-baseline text-danger fw-bold">*</span>
                </p>
                <InputTextarea
                  value={reasonRevokeCandidacyTextArea}
                  maxLength={500}
                  rows={10}
                  cols={50}
                  onKeyUp={onKeyUp}
                  onKeyPress={onKeyPress}
                  onPaste={onPaste}
                  placeholder="Type comment here"
                  className="w-100"
                  onChange={(e) => {
                    const value = e.target.value;
                    setReasonRevokeCandidacyTextarea(value);
                    setRevokeCommentCharLimit(value.length);
                    setAlternativeScheduleAlert(value.trim().length === 0);
                    setIsButtonDisabled(value.trim().length === 0);
                  }}
                  autoResize
                />

                <p className="pe-2 charLimit">
                  <span>*Required Field</span>
                  <span className="float-end">
                    {revokeCommentCharLimit} Character Limit
                  </span>
                </p>
              </>
            )}
            {saveAndLockConfirmation && (
              <>
                <h3 className="text-center mt-5 pt-5">
                  Your request has been sent!
                </h3>
                <div
                  className="justify-content-center d-flex"
                  style={{
                    backgroundColor: "#D4D4FF",
                    borderRadius: "8px",
                    color: "#3A21AE",
                    padding: "10px 15px",
                  }}
                >
                  <i
                    className="pi pi-clock mt-2"
                    style={{ fontSize: "2em" }}
                  ></i>
                  <div className="ms-2 pt-1">
                    <span className="pt-2 w-100 confirmedScheduledText d-block">
                      Your confirmed schedule is -{" "}
                      {selectedCountryTemplateDisplay(selectedSchedule1, {
                        placeholder: "Select preferred schedule #1",
                      })}
                    </span>
                  </div>
                </div>
                <br />
                <p className="text-center">
                  Congratulations! Your preferred schedule has been accepted!
                </p>

                {/* TTECONNECT-2753: Training-schedule acknowledgment disclaimer (display-only),
                    shown beneath the confirmed schedule. Copy per story AC. */}
                <div
                  className="my-schedule-disclaimer mt-3"
                  style={{
                    borderLeft: "4px solid #3A21AE",
                    backgroundColor: "#F5F4FF",
                    borderRadius: "8px",
                    padding: "12px 16px",
                    marginBottom: "35px",
                    textAlign: "justify",
                    fontSize: "12px",
                    lineHeight: "18px",
                    color: "#333333",
                  }}
                >
                  <strong
                    style={{
                      display: "block",
                      marginBottom: "4px",
                      color: "#3A21AE",
                      fontSize: "11px",
                      letterSpacing: "0.5px",
                      textTransform: "uppercase",
                    }}
                  >
                    Disclaimer
                  </strong>
                  &ldquo;I understand that for the duration of training I will
                  work the following training schedule{" "}
                  <strong>
                    Start Timing: {selectedSchedule1?.ShiftTimings} | Days:{" "}
                    {selectedSchedule1?.DaysWorked} | Shift Duration (hr):{" "}
                    {selectedSchedule1?.ShiftSpan}
                  </strong>
                  . After Training is complete, I will begin working within the
                  agreed upon Window of Availability listed above. I also
                  understand that I MAY NOT be permitted to change My Window of
                  Availability until after I have completed 90 days of
                  employment. TTEC MAY periodically conduct Schedule
                  Realignments which may involve a possible change in your Window
                  of Availability. Performance ranking is an integral component
                  in your ability to change your Window of Availability during a
                  schedule realignment. TTEC believes in recognizing employees
                  for good performance and subsequently providing opportunities
                  for you to adjust your Window of Availability. Your employment
                  is at-will. The above schedule is not a guarantee of work or
                  hours of work. TTEC reserves the right to modify scheduling at
                  the Company&rsquo;s discretion.&rdquo;
                </div>
              </>
            )}
            {alternateScheduleThanks && !saveAndLockConfirmation && (
              <>
                <h3 className="text-center mt-5 pt-5">
                  Your request has been sent!
                </h3>
                <p className="text-center">
                  We will review the submitted schedule request and get back to
                  you shortly. Check your TTEC email for updates.
                </p>
              </>
            )}

            {revokeCandidacyThanks && (
              <>
                <h3 className="text-center mt-5 pt-5">Thank you! </h3>
                <p className="text-center">
                  You've successfully requested to revoke your candidacy. We
                  will review it and get back to you.
                </p>
              </>
            )}
          </div>
        </div>
      </div>

      {/* TTECONNECT-2715: "No schedules available" informational pop-up.
          X (onHide) and OK both close it and return to the My Schedule modal. */}
      <Dialog
        header={getNoScheduleTitle()}
        visible={noScheduleDialogVisible}
        style={{ width: "30vw" }}
        onHide={closeNoScheduleDialog}
        footer={
          <div className="d-flex float-end">
            <Button
              label="OK"
              className="p-button-primary"
              onClick={closeNoScheduleDialog}
              autoFocus
            />
          </div>
        }
      >
        <p className="mt-2">
          You will be informed via email and SMS notifications once schedules
          are available for your class
        </p>
      </Dialog>
    </Dialog>
  );
}
